<page-header icon="file" header="{{'Visitor log' | translate}}" [subHeader]="'View data for the selected period.' | translate">
    <page-header-content>
        <statistics-date-picker
            (onApply)="updateDateRange()"
            [(date)]="date"
            dateRangeGroup="statistics"
            class="pull-right">
        </statistics-date-picker>
    </page-header-content>
</page-header>
<div class="row outer-b-xlarge" *ngIf="loading">
    <div class="col-48 text-center">
        <span class="fa fa-spinner fa-spin fa-3x fa-fw" aria-hidden="true"></span>
    </div>
</div>
<ng-container *ngFor="let item of listItem"><div *ngIf="!loading" class="pb-5">
    <div class="col-48 pl-0">
        <p class="mb-4 header-block">{{item.title}}</p>
    </div>

    <div>
        <table class="table table-hover">
            <thead>
                <tr>
                    <th class="col-sm-3 col-md-3 text-center" translate>Time</th>
                    <th class="col-sm-3 col-md-3 text-center" translate>Location</th>
                    <th class="col-sm-3 col-md-3 text-center" translate>Devices</th>
                    <th class="col-sm-3 col-md-3 text-center" translate>Entry</th>
                    <th class="col-sm-3 col-md-3 text-center" translate>Page Views</th>
                    <th class="col-sm-3 col-md-3 text-center" translate>Actions</th>
                    <th class="col-sm-3 col-md-3 text-center" translate>Duration</th>
                    <th class="col-sm-3 col-md-3 text-center" translate>No. Visits</th>
                    <th class="col-sm-3 col-md-3 text-center"></th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let page of item.pages" class=" card panel-monsido-card">
                    <td class="text-v-middle text-center">
                    </td>
                    <td class="text-v-middle text-center d-flex">
                    </td>
                    <td class="text-v-middle text-center"></td>
                    <td class="text-v-middle text-center">
                    </td>
                    <td class="text-v-middle text-center">{{page.views}}</td>
                    <td class="text-v-middle text-center">
                    </td>
                    <td class="text-v-middle text-center">{{page.duration}}</td>
                    <td class="text-v-middle text-center">
                    </td>
                    <td class="text-v-middle text-center font-size-18 color-info-btn">
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div></ng-container>

<div *ngIf="focusItem" class="border-left-3-grey">
    <div class="col-28 col-sm-48 card panel-monsido-card">
        <div class="card-body col-48">
            <table class="col-48">
                <tbody>
                    <td class="w-35px">
                    </td>
                    <td>
                    </td>
                </tbody>
            </table>
        </div>
    </div>

    <div class="p-1 col-28">
        <div class="card panel-monsido-card p-3">
            <div class="font-size-24 col-48" translate>Visitor Summary</div>

            <div class="card-body col-48 line-border-bottom pb-5">
                <table class="col-48">
                    <tbody>
                    </tbody>
                </table>
            </div>

            <div class="card-body col-48 line-border-bottom pb-3">
                <div class="p-2">
                    <span class="fa fa-refresh icon-color-2e97f8" aria-hidden="true"></span>
                    <span class="pl-2" translate>Returning customer</span>
                </div>
                <div class="p-2">
                    <table class="col-48">
                    </table>
                    <div class="clearfix"></div>
                </div>
                <div class="p-2">
                    <table class="col-48">
                    </table>
                    <div class="clearfix"></div>
                </div>
            </div>

            <div class="card-body col-48 pb-3">
                    <div class="p-2">
                        <span class="fa fa-firefox icon-color-2e97f8 pr-2" aria-hidden="true"></span>
                        <span class="fa fa-firefox icon-color-2e97f8 pr-2" aria-hidden="true"></span>
                        <span class="fa fa-windows icon-color-2e97f8 pr-2" aria-hidden="true"></span>
                        <span class="fa fa-desktop icon-color-2e97f8 pr-2" aria-hidden="true"></span>
                    </div>
                    <div class="p-2">
                        <div>Resolution: 1600x900</div>
                    </div>
                    <div class="p-2">
                        <div>
                        </div>
                        <div>IP {{focusItem.ip}}</div>
                    </div>
                    <div class="p-2">
                        <table class="col-48">
                        </table>
                        <div class="clearfix"></div>
                    </div>
                </div>

            <div class="clearfix"></div>
        </div>
    </div>

    <div class="p-1 col-20">
        <div class="p-3 col-48 card panel-monsido-card" *ngFor="let item of focusItem.dayVisited">
            <div class="card-body">
                <div class="pb-1">
                    <div class="col-24 pl-0">
                    </div>
                    <div class="col-24 text-right pr-0">{{item.day}}</div>
                    <div class="clearfix"></div>
                </div>
                <div class="background-F2F3F7 p-1">
                    <strong translate>Page Views</strong>: {{item.link.length}}
                </div>
                <div class="p-1">
                </div>
            </div>
        </div>
    </div>

    <div class="clearfix"></div>
</div>